import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {FruitsGameConfig} from "../FruitsGameConfig";
import {FruitsSoundConfig} from "../FruitsSoundConfig";
import {FruitsHelper} from "../utils/FruitsHelper";

export interface FruitsSprite extends TimelineSprite, PIXI.Sprite {
    reel:number;
    reelIndexes:[number, number];
}


export class FruitsBeforeSpinStopRandomFeatureView extends BaseView {

    private _orientation:Orientation = Orientation.LANDSCAPE;

    private _layer:ScalableLayer;
    private _container_0:PIXI.Container;
    private _container_1:PIXI.Container;
    private _appearSprites:FruitsSprite[];
    private _disappearSprites:FruitsSprite[];
    private _normalSymSprites:FruitsSprite[];
    private _normalSymsBg:FruitsSprite[];
    public _isAborted:boolean = false;
    private _order:number[];
    private _landscapeOffsets:number[][];
    private _portraitOffsets:number[][];
    private _positions:number[];
    private _symLandscapeOffsets:number[][];
    private _symPortraitOffsets:number[][];

    constructor() {
        super();

        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.STICKY_SYMBOL.name);

        this._landscapeOffsets = [[0, 0], [0, -1], [-1, 0], [-1, -1], [0, 0], [0, -1], [0, -2], [-1, 0], [-1, -1], [-1, -2], [-2, 0], [-1, -1], [-2, -2], [-3, 0], [-3, -1], [-3, -2]];
        this._portraitOffsets = [[0, 0], [1, 0], [0, -1], [1, -1], [-4, -4], [-3, -4], [-2, -4], [-4, -5], [-3, -5], [-2, -5], [-4, -6], [-3, -5], [-2, -6], [-4, -7], [-3, -7], [-2, -7]];
        this._symLandscapeOffsets = [[-1, -0.5], [-1, 0], [-1, -0.5], [-1, 0], [-1.5, -2], [-2, -2], [-2, -2], [-2, -1.5], [-2, -1.5], [-2, -2], [-2, -1.5], [-2, -1.5], [-2, -2], [-2, -1.5], [-2, -1.5], [-2, -2]];
        this._symPortraitOffsets = [[0, 0], [0.5, 0], [0, -2.5], [0.5, -2.5], [-3, -5.5], [-3, -5.5], [-3, -5.5], [-3, -5], [-3, -5], [-3, -5], [-3, -5.5], [-3, -5.5], [-3, -5.5], [-3, -7.5], [-3, -7.5], [-3, -7.5]];

    }

    protected initAnimations():void {

        this._container_0 = new PIXI.Container();
        this._container_1 = new PIXI.Container();

        this._layer.addChild(this._container_0);
        this._layer.addChild(this._container_1);

    }

    private createAppear(reel:number):FruitsSprite {

        let offsets = this._orientation === Orientation.LANDSCAPE ? this._landscapeOffsets : this._portraitOffsets;


        let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(reel);
        let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);

        const sprite:FruitsSprite = new TimelineSprite(GameResources.getTextures("mystery_fx_appear")) as FruitsSprite;
        sprite.anchor.set(0.5, 0.5);
        sprite.scale.set(1, 1);
        sprite.hide();
        sprite.reel = reel;
        sprite.reelIndexes = reelIndexes;

        let xOffset = offsets[reel][0];
        let yOffset = offsets[reel][1];
        sprite.position.set(rectPos[0] + xOffset, rectPos[1] + (-97 + yOffset));

        this._container_1.addChild(sprite);

        return sprite;
    }

    private createDisappear(reel:number):FruitsSprite {

        let offsets = this._orientation === Orientation.LANDSCAPE ? this._landscapeOffsets : this._portraitOffsets;

        let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(reel);
        let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);

        const sprite:FruitsSprite = new TimelineSprite(GameResources.getTextures("mystery_fx_disappear")) as FruitsSprite;
        sprite.anchor.set(0.5, 0.5);
        sprite.scale.set(1, 1);
        sprite.reel = reel;
        sprite.reelIndexes = reelIndexes;
        sprite.hide();

        let xOffset = offsets[reel][0];
        let yOffset = offsets[reel][1];
        sprite.position.set(rectPos[0] + xOffset, rectPos[1] + yOffset);

        this._container_1.addChild(sprite);

        return sprite;
    }

    private createNormalSym(reel:number, symName:string):FruitsSprite {

        let offsets = this._orientation === Orientation.LANDSCAPE ? this._symLandscapeOffsets : this._symPortraitOffsets;

        let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(reel);
        let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);

        const sprite:FruitsSprite = new PIXI.Sprite(GameResources.getTextures(`${symName}_normal`)[0]) as FruitsSprite;
        sprite.visible = false;
        sprite.anchor.set(0.5, 0.5);

        if(symName === "W") {
            sprite.scale.set(1, 1);
        } else {
            sprite.scale.set(0.5, 0.5);
        }

        sprite.reel = reel;
        sprite.reelIndexes = reelIndexes;

        let xOffset = offsets[reel][0];
        let yOffset = offsets[reel][1];
        sprite.position.set(rectPos[0] + xOffset, rectPos[1] + yOffset);

        this._container_0.addChild(sprite);

        return sprite;
    }

    private createSymBg(reel:number):FruitsSprite {

        let offsets = this._orientation === Orientation.LANDSCAPE ? this._landscapeOffsets : this._portraitOffsets;

        let reelIndexes:[number, number] = FruitsHelper.translateReelIndex(reel);
        let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);

        const sprite:FruitsSprite = new PIXI.Sprite(GameResources.getTextures("singleReelBG_A")[0]) as FruitsSprite;
        sprite.visible = false;
        sprite.anchor.set(0.5, 0.5);
        sprite.reel = reel;

        sprite.reelIndexes = reelIndexes;

        let xOffset = offsets[reel][0];
        let yOffset = offsets[reel][1];
        sprite.position.set(rectPos[0] + xOffset, rectPos[1] + yOffset);

        this._container_0.addChild(sprite);

        return sprite;
    }

    public prepareAssets(positions:number[], symName:string):void {

        this._positions = positions;

        this._appearSprites = [];
        this._disappearSprites = [];
        this._normalSymsBg = [];
        this._normalSymSprites = [];
        this._order = [];

        for(let i:number = 0; i < positions.length; i++) {
            this._appearSprites.push(this.createAppear(positions[i]));
            this._disappearSprites.push(this.createDisappear(positions[i]));
            this._normalSymsBg.push(this.createSymBg(positions[i]));
            this._normalSymSprites.push(this.createNormalSym(positions[i], symName));

            this._order.push(i);
        }
    }

    public getAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        this._container_0.alpha = 1;
        this._container_1.alpha = 1;

        this._isAborted = false;

        tl.add(this.getAppearAnimation());
        tl.add(() => this.showNormalSymsAndBg());
        return tl;
    }

    private static shuffleRandomOverlayPositions(array:number[]):number[] {
        for(let i:number = array.length - 1; i > 0; i--) {
            const rand:number = Math.floor(Math.random() * (i + 1));
            [array[i], array[rand]] = [array[rand], array[i]];
        }
        return array;
    }

    private getAppearAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        const shuffledOrder:number[] = FruitsBeforeSpinStopRandomFeatureView.shuffleRandomOverlayPositions(this._order);

        let advance = 0;

        for(let i:number = 0; i < shuffledOrder.length; i++) {
            if(i === 1) {
                advance = 0.08;
            }

            let randomIndex = shuffledOrder[i];
            tl.add([
                this._appearSprites[randomIndex].getAnimationAutoShowHide(true, false),
                () => FruitsBeforeSpinStopRandomFeatureView.playSound()
            ], `-=${advance}`);

            if(advance < 0.4) {

                advance = advance * 1.62;
            }

        }
        return tl;
    }

    public getDisappearAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playEffect(FruitsSoundConfig.WRAPPERS_POP));
        for(let i:number = 0; i < this._disappearSprites.length; i++) {
            tl.add([
                () => this._appearSprites[i].hide(),
                this._disappearSprites[i].getAnimationAutoShowHide(true, true)
            ], 0);
        }


        return tl;
    }

    private showNormalSymsAndBg():void {
        for(let i:number = 0; i < this._normalSymSprites.length; i++) {
            this._normalSymsBg[i].visible = true;
            this._normalSymSprites[i].visible = true;
        }
    }

    public resetReel(reelId:number):void {
        let newIndex = this._positions.indexOf(reelId);

        this._normalSymSprites[newIndex].visible = false;
        this._normalSymsBg[newIndex].visible = false;

    }

    public resetRandomFeature():void {
        this._container_0.removeChildren();
        this._container_1.removeChildren();
        this._appearSprites = [];
        this._disappearSprites = [];
        this._normalSymSprites = [];
        this._normalSymsBg = [];
        this._order = [];
        this._isAborted = false;
    }

    private static playSound():void {
        SlotGame.sound.playEffect(FruitsSoundConfig.WRAPPER);
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;

        let offsets = this._orientation === Orientation.LANDSCAPE ? this._landscapeOffsets : this._portraitOffsets;

        for(let i:number = 0; i < 16; i++) {

            if(this._normalSymSprites && this._normalSymSprites[i]) {
                let reelIndexes = this._normalSymSprites[i].reelIndexes;
                let reel = this._normalSymSprites[i].reel;

                let symOffsets = this._orientation === Orientation.LANDSCAPE ? this._symLandscapeOffsets : this._symPortraitOffsets;

                let xOffset = symOffsets[reel][0];
                let yOffset = symOffsets[reel][1];
                let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);
                this._normalSymSprites[i].position.set(rectPos[0] + xOffset, rectPos[1] + yOffset);
            }

            if(this._normalSymsBg && this._normalSymsBg[i]) {
                let reelIndexes = this._normalSymsBg[i].reelIndexes;
                let reel = this._normalSymsBg[i].reel;
                let xOffset = offsets[reel][0];
                let yOffset = offsets[reel][1];
                let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);
                this._normalSymsBg[i].position.set(rectPos[0] + xOffset, rectPos[1] + yOffset);
            }

            if(this._appearSprites && this._appearSprites[i]) {
                let reelIndexes = this._appearSprites[i].reelIndexes;
                let reel = this._appearSprites[i].reel;
                let xOffset = offsets[reel][0];
                let yOffset = offsets[reel][1];
                let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);
                this._appearSprites[i].position.set(rectPos[0] + xOffset, rectPos[1] + (-97 + yOffset));
            }

            if(this._disappearSprites && this._disappearSprites[i]) {
                let reelIndexes = this._disappearSprites[i].reelIndexes;
                let reel = this._disappearSprites[i].reel;
                let xOffset = offsets[reel][0];
                let yOffset = offsets[reel][1];
                let rectPos:number[] = FruitsHelper.getSymbolPosition(reelIndexes[0], reelIndexes[1], this._orientation);
                this._disappearSprites[i].position.set(rectPos[0] + xOffset, rectPos[1] + yOffset);
            }
        }

    }
}